class RegistrationResult {
  constructor(success) {
    this.success = success;
  }
}

export { RegistrationResult };
